import { render, staticRenderFns } from "./sp-testimonials.vue?vue&type=template&id=7d8e20bb"
import script from "./sp-testimonials.vue?vue&type=script&lang=js"
export * from "./sp-testimonials.vue?vue&type=script&lang=js"
import style0 from "./sp-testimonials.vue?vue&type=style&index=0&id=7d8e20bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,VBtn: require('/app/node_modules/vuetify/lib/components/VBtn/VBtn.js').default})


/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
